// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cr-page {
  font-family:
    Inter,
    system-ui,
    -apple-system,
    'Segoe UI',
    Roboto,
    sans-serif;
  color: var(--v2-primary);
  background: var(--v2-bg);
  min-height: 100vh;
  font-size: 14px;
  line-height: 1.45;
}
.cr-page a {
  color: var(--v2-primary);
  text-decoration: none;
}
.cr-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 28px;
  background: #fff;
  border-bottom: 1px solid var(--v2-border);
}
.cr-cancel {
  color: var(--v2-text-2);
  font: inherit;
  font-weight: 500;
  background: none;
  border: 0;
  cursor: pointer;
}
.cr-main {
  padding: 32px 24px 48px;
}
.cr-wrap {
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.cr-h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.01em;
  white-space: nowrap;
}
.cr-h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}
.cr-types {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
}
.cr-type {
  text-align: left;
  font: inherit;
  color: var(--v2-primary);
  cursor: pointer;
  background: #fff;
  border: 1px solid var(--v2-border);
  border-radius: 14px;
  padding: 16px 18px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.cr-type.is-on {
  border: 2px solid var(--v2-primary);
  padding: 15px 17px;
  cursor: default;
}
.cr-type-icon {
  width: 36px;
  height: 36px;
  flex: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cr-card {
  background: #fff;
  border: 1px solid var(--v2-border);
  border-radius: 14px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.cr-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.cr-field label {
  font-weight: 600;
  font-size: 13px;
}
.cr-input {
  font: inherit;
  height: 42px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 0 14px;
  color: var(--v2-primary);
  outline: none;
  width: 100%;
  box-sizing: border-box;
}
.cr-input:focus {
  border-color: var(--v2-primary);
}
.cr-input.is-error {
  border-color: var(--v2-red);
}
.cr-textarea {
  height: auto;
  padding: 12px 14px;
  resize: vertical;
}
.cr-error {
  font-size: 12px;
  color: var(--v2-red);
}
.cr-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 14px;
  border-radius: 9px;
  border: 1px solid #d1d5db;
  background: #fff;
  font: inherit;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  color: var(--v2-primary);
  white-space: nowrap;
  flex-shrink: 0;
}
.cr-btn:disabled {
  color: var(--v2-faint);
  cursor: default;
}
.cr-choices {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
}
.cr-choice {
  text-align: left;
  font: inherit;
  color: var(--v2-primary);
  cursor: pointer;
  background: #fff;
  border: 1px solid var(--v2-border);
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cr-choice.is-on {
  border: 2px solid var(--v2-primary);
  padding: 13px 15px;
}
.cr-tag {
  font-size: 11px;
  font-weight: 700;
  color: var(--v2-muted);
  letter-spacing: 0.03em;
}
.cr-submit {
  display: inline-flex;
  align-items: center;
  height: 46px;
  padding: 0 22px;
  border-radius: 11px;
  background: var(--v2-primary);
  color: #fff;
  font: inherit;
  font-weight: 600;
  border: 0;
  cursor: pointer;
  white-space: nowrap;
}
.cr-submit:hover {
  background: #374151;
}
.cr-submit:disabled {
  background: var(--v2-border);
  color: var(--v2-faint);
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/pages/assistant-create/create.css"],"names":[],"mappings":"AAAA;EACE;;;;;;cAMY;EACZ,wBAAwB;EACxB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":[".cr-page {\n  font-family:\n    Inter,\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    Roboto,\n    sans-serif;\n  color: var(--v2-primary);\n  background: var(--v2-bg);\n  min-height: 100vh;\n  font-size: 14px;\n  line-height: 1.45;\n}\n.cr-page a {\n  color: var(--v2-primary);\n  text-decoration: none;\n}\n.cr-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 28px;\n  background: #fff;\n  border-bottom: 1px solid var(--v2-border);\n}\n.cr-cancel {\n  color: var(--v2-text-2);\n  font: inherit;\n  font-weight: 500;\n  background: none;\n  border: 0;\n  cursor: pointer;\n}\n.cr-main {\n  padding: 32px 24px 48px;\n}\n.cr-wrap {\n  max-width: 760px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.cr-h1 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n}\n.cr-h2 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n}\n.cr-types {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 12px;\n}\n.cr-type {\n  text-align: left;\n  font: inherit;\n  color: var(--v2-primary);\n  cursor: pointer;\n  background: #fff;\n  border: 1px solid var(--v2-border);\n  border-radius: 14px;\n  padding: 16px 18px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n.cr-type.is-on {\n  border: 2px solid var(--v2-primary);\n  padding: 15px 17px;\n  cursor: default;\n}\n.cr-type-icon {\n  width: 36px;\n  height: 36px;\n  flex: none;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.cr-card {\n  background: #fff;\n  border: 1px solid var(--v2-border);\n  border-radius: 14px;\n  padding: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.cr-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.cr-field label {\n  font-weight: 600;\n  font-size: 13px;\n}\n.cr-input {\n  font: inherit;\n  height: 42px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  padding: 0 14px;\n  color: var(--v2-primary);\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n}\n.cr-input:focus {\n  border-color: var(--v2-primary);\n}\n.cr-input.is-error {\n  border-color: var(--v2-red);\n}\n.cr-textarea {\n  height: auto;\n  padding: 12px 14px;\n  resize: vertical;\n}\n.cr-error {\n  font-size: 12px;\n  color: var(--v2-red);\n}\n.cr-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 38px;\n  padding: 0 14px;\n  border-radius: 9px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  font: inherit;\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  color: var(--v2-primary);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.cr-btn:disabled {\n  color: var(--v2-faint);\n  cursor: default;\n}\n.cr-choices {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 10px;\n}\n.cr-choice {\n  text-align: left;\n  font: inherit;\n  color: var(--v2-primary);\n  cursor: pointer;\n  background: #fff;\n  border: 1px solid var(--v2-border);\n  border-radius: 12px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.cr-choice.is-on {\n  border: 2px solid var(--v2-primary);\n  padding: 13px 15px;\n}\n.cr-tag {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--v2-muted);\n  letter-spacing: 0.03em;\n}\n.cr-submit {\n  display: inline-flex;\n  align-items: center;\n  height: 46px;\n  padding: 0 22px;\n  border-radius: 11px;\n  background: var(--v2-primary);\n  color: #fff;\n  font: inherit;\n  font-weight: 600;\n  border: 0;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.cr-submit:hover {\n  background: #374151;\n}\n.cr-submit:disabled {\n  background: var(--v2-border);\n  color: var(--v2-faint);\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
